export default __webpack_public_path__ + "static/media/litecoin1-gj.8f157a42.webp";